const toHex = (d: string | number) => ('0x' + Number(d).toString(16))
export default toHex